var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 20,
    viewBox: "0 0 100 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8679 2.88418C10.5469 2.11218 9.45292 2.11218 9.13192 2.88418L7.30192 7.28518L2.54892 7.66618C1.71592 7.73318 1.37792 8.77318 2.01292 9.31718L5.63292 12.4192L4.52692 17.0562C4.33292 17.8692 5.21792 18.5122 5.93192 18.0762L9.99992 15.5912L14.0689 18.0762C14.7819 18.5122 15.6669 17.8692 15.4729 17.0562L14.3669 12.4192L17.9869 9.31718C18.6219 8.77318 18.2839 7.73318 17.4509 7.66718L12.6989 7.28518L10.8679 2.88418Z",
    fill: "#38FBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8679 2.88418C30.5469 2.11218 29.4529 2.11218 29.1319 2.88418L27.3019 7.28518L22.5489 7.66618C21.7159 7.73318 21.3779 8.77318 22.0129 9.31718L25.6329 12.4192L24.5269 17.0562C24.3329 17.8692 25.2179 18.5122 25.9319 18.0762L29.9999 15.5912L34.0689 18.0762C34.7819 18.5122 35.6669 17.8692 35.4729 17.0562L34.3669 12.4192L37.9869 9.31718C38.6219 8.77318 38.2839 7.73318 37.4509 7.66718L32.6989 7.28518L30.8679 2.88418Z",
    fill: "#38FBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8679 2.88418C50.5469 2.11218 49.4529 2.11218 49.1319 2.88418L47.3019 7.28518L42.5489 7.66618C41.7159 7.73318 41.3779 8.77318 42.0129 9.31718L45.6329 12.4192L44.5269 17.0562C44.3329 17.8692 45.2179 18.5122 45.9319 18.0762L49.9999 15.5912L54.0689 18.0762C54.7819 18.5122 55.6669 17.8692 55.4729 17.0562L54.3669 12.4192L57.9869 9.31718C58.6219 8.77318 58.2839 7.73318 57.4509 7.66718L52.6989 7.28518L50.8679 2.88418Z",
    fill: "#38FBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8679 2.88418C70.5469 2.11218 69.4529 2.11218 69.1319 2.88418L67.3019 7.28518L62.5489 7.66618C61.7159 7.73318 61.3779 8.77318 62.0129 9.31718L65.6329 12.4192L64.5269 17.0562C64.3329 17.8692 65.2179 18.5122 65.9319 18.0762L69.9999 15.5912L74.0689 18.0762C74.7819 18.5122 75.6669 17.8692 75.4729 17.0562L74.3669 12.4192L77.9869 9.31718C78.6219 8.77318 78.2839 7.73318 77.4509 7.66718L72.6989 7.28518L70.8679 2.88418Z",
    fill: "#38FBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8679 2.88418C90.5469 2.11218 89.4529 2.11218 89.1319 2.88418L87.3019 7.28518L82.5489 7.66618C81.7159 7.73318 81.3779 8.77318 82.0129 9.31718L85.6329 12.4192L84.5269 17.0562C84.3329 17.8692 85.2179 18.5122 85.9319 18.0762L89.9999 15.5912L94.0689 18.0762C94.7819 18.5122 95.6669 17.8692 95.4729 17.0562L94.3669 12.4192L97.9869 9.31718C98.6219 8.77318 98.2839 7.73318 97.4509 7.66718L92.6989 7.28518L90.8679 2.88418Z",
    fill: "#38FBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars3);
export default __webpack_public_path__ + "static/media/Stars3.e482ec30466dd0ae43e5b1c5393de55c.svg";
export { ForwardRef as ReactComponent };